<div class="flow-content">
  <div class="header-container">
    <app-primary-back-button
      *ngIf="showBackToLogin$ | async"
      label="Back to Login"
      i18n-label
      (backClicked)="goBack()" />
    <app-logo [width]="'5.25rem'" [height]="'3rem'" [logoImage]="'assets/logo/navy/spp-logo.svg'" />
    <span class="header-title" i18n>Create an Account</span>
  </div>
  <app-stepper [selectedIndex]="currentStep$ | async" [linear]="true">
    <cdk-step label="Personal Information" i18n-label />
    <cdk-step label="Contact Information" i18n-label />
    <cdk-step label="Login Details" i18n-label />
  </app-stepper>
  <ng-container *ngComponentOutlet="currentStepComponent$ | async" />
</div>
